export default __webpack_public_path__ + "static/media/picture_home_02.b8c05cc6.png";